<template>
  <div v-if="isVisible" class="cookie-consent">
    <div class="cookie-consent-content">
      <div class="cookie-main">
        <div class="cookie-text">
          <h3>Cookie-Einstellungen</h3>
          <p>
            Wir nutzen Cookies und ähnliche Technologien, um Ihnen die bestmögliche Nutzung unserer Website zu ermöglichen.
            <button @click="showDetails = !showDetails" class="details-toggle">
              {{ showDetails ? 'Details ausblenden' : 'Details einblenden' }}
            </button>
          </p>
        </div>

        <div v-if="showDetails" class="cookie-options">
          <div class="cookie-option">
            <label class="checkbox-container">
              <input type="checkbox" checked disabled>
              <span class="checkmark"></span>
              <span class="label-text">Technisch notwendige Cookies</span>
            </label>
            <span class="info-text">Erforderlich für grundlegende Funktionen wie Session-Management und Formular-Speicherung</span>
          </div>

          <div class="cookie-option">
            <label class="checkbox-container">
              <input 
                type="checkbox" 
                v-model="cookieSettings.analytics"
                @change="updateCookieSettings"
              >
              <span class="checkmark"></span>
              <span class="label-text">Google Analytics 4</span>
            </label>
            <span class="info-text">Hilft uns durch anonymisierte Nutzungsstatistiken die Website zu verbessern</span>
          </div>
        </div>
      </div>

      <div class="cookie-actions">
        <div class="cookie-buttons">
          <button class="btn btn-accept" @click="acceptAll">
            Alle akzeptieren
          </button>
          <button class="btn btn-save" @click="saveSettings">
            Auswahl speichern
          </button>
          <button class="btn btn-reject" @click="declineAll">
            Nur notwendige
          </button>
        </div>
        <div class="cookie-links">
          <router-link to="/datenschutz">Datenschutz</router-link>
          <span class="separator">|</span>
          <router-link to="/impressum">Impressum</router-link>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import analyticsService from '@/services/analyticsService';

export default {
  name: 'CookieConsent',
  data() {
    return {
      isVisible: false,
      showDetails: false,
      cookieSettings: {
        essential: true, // Immer aktiv
        analytics: false
      }
    }
  },
  mounted() {
    const savedSettings = localStorage.getItem('cookieSettings');
    if (!savedSettings) {
      this.isVisible = true;
    } else {
      const settings = JSON.parse(savedSettings);
      this.cookieSettings = { ...this.cookieSettings, ...settings };
      
      const expiryDate = localStorage.getItem('cookieSettingsExpiry');
      if (expiryDate && new Date(expiryDate) < new Date()) {
        this.isVisible = true;
        localStorage.removeItem('cookieSettings');
        localStorage.removeItem('cookieSettingsExpiry');
      } else {
        // Analytics-Consent setzen basierend auf gespeicherten Einstellungen
        analyticsService.setConsent(this.cookieSettings.analytics);
      }
    }
  },
  methods: {
    saveSettings() {
      const expiryDate = new Date();
      expiryDate.setMonth(expiryDate.getMonth() + 6);
      
      localStorage.setItem('cookieSettings', JSON.stringify(this.cookieSettings));
      localStorage.setItem('cookieSettingsExpiry', expiryDate.toISOString());
      
      this.$emit('cookieSettingsChanged', this.cookieSettings);
      this.isVisible = false;

      // Analytics-Consent setzen
      analyticsService.setConsent(this.cookieSettings.analytics);
    },
    acceptAll() {
      this.cookieSettings.analytics = true;
      this.saveSettings();
    },
    declineAll() {
      this.cookieSettings.analytics = false;
      this.saveSettings();
    },
    updateCookieSettings() {
      // Analytics-Consent sofort aktualisieren bei Checkbox-Änderung
      analyticsService.setConsent(this.cookieSettings.analytics);
    }
  }
}
</script>

<style scoped>
.cookie-consent {
  position: fixed;
  bottom: 0;
  left: 0;
  right: 0;
  background-color: rgba(255, 255, 255, 0.98);
  box-shadow: 0 -2px 8px rgba(0, 0, 0, 0.1);
  z-index: 9999;
  font-family: 'Roboto', sans-serif;
  border-top: 2px solid var(--primary-color, #1a3b89);
}

.cookie-consent-content {
  max-width: 1200px;
  margin: 0 auto;
  padding: 1rem;
}

.cookie-main {
  margin-bottom: 1rem;
}

.cookie-text {
  margin-bottom: 1rem;
}

.cookie-text h3 {
  font-size: 1.2rem;
  color: var(--primary-color, #1a3b89);
  margin: 0 0 0.5rem 0;
}

.cookie-text p {
  margin: 0;
  font-size: 0.9rem;
  color: #666;
}

.details-toggle {
  background: none;
  border: none;
  color: var(--primary-color, #1a3b89);
  text-decoration: underline;
  cursor: pointer;
  padding: 0;
  margin-left: 0.5rem;
  font-size: 0.9rem;
}

.cookie-options {
  display: grid;
  gap: 0.75rem;
  margin: 1rem 0;
  padding: 1rem;
  background-color: #f8f9fa;
  border-radius: 4px;
}

.cookie-option {
  display: flex;
  align-items: center;
  justify-content: space-between;
}

/* Checkbox styling */
.checkbox-container {
  display: flex;
  align-items: center;
  cursor: pointer;
  user-select: none;
}

.checkbox-container input {
  position: absolute;
  opacity: 0;
  cursor: pointer;
  height: 0;
  width: 0;
}

.checkmark {
  height: 18px;
  width: 18px;
  background-color: #fff;
  border: 2px solid #ddd;
  border-radius: 3px;
  margin-right: 8px;
  position: relative;
}

.checkbox-container:hover input ~ .checkmark {
  border-color: var(--primary-color, #1a3b89);
}

.checkbox-container input:checked ~ .checkmark {
  background-color: var(--primary-color, #1a3b89);
  border-color: var(--primary-color, #1a3b89);
}

.checkmark:after {
  content: "";
  position: absolute;
  display: none;
}

.checkbox-container input:checked ~ .checkmark:after {
  display: block;
}

.checkbox-container .checkmark:after {
  left: 5px;
  top: 2px;
  width: 4px;
  height: 8px;
  border: solid white;
  border-width: 0 2px 2px 0;
  transform: rotate(45deg);
}

.label-text {
  font-weight: 500;
  font-size: 0.9rem;
}

.info-text {
  font-size: 0.8rem;
  color: #666;
}

.cookie-actions {
  display: flex;
  justify-content: space-between;
  align-items: center;
  flex-wrap: wrap;
  gap: 1rem;
}

.cookie-buttons {
  display: flex;
  gap: 0.5rem;
}

.btn {
  padding: 0.5rem 1rem;
  border: none;
  border-radius: 4px;
  cursor: pointer;
  font-size: 0.9rem;
  font-weight: 500;
  transition: all 0.2s;
}

.btn-accept {
  background-color: var(--primary-color, #1a3b89);
  color: white;
}

.btn-accept:hover {
  background-color: var(--primary-dark-color, #132c66);
}

.btn-save {
  background-color: #4CAF50;
  color: white;
}

.btn-save:hover {
  background-color: #45a049;
}

.btn-reject {
  background-color: transparent;
  border: 1px solid #666;
  color: #666;
}

.btn-reject:hover {
  background-color: #f8f9fa;
}

.cookie-links {
  font-size: 0.8rem;
}

.cookie-links a {
  color: var(--primary-color, #1a3b89);
  text-decoration: none;
}

.cookie-links a:hover {
  text-decoration: underline;
}

.separator {
  margin: 0 0.5rem;
  color: #666;
}

@media (max-width: 768px) {
  .cookie-consent-content {
    padding: 1rem;
  }

  .cookie-option {
    flex-direction: column;
    align-items: flex-start;
    gap: 0.25rem;
  }

  .info-text {
    margin-left: 26px;
  }

  .cookie-actions {
    flex-direction: column;
  }

  .cookie-buttons {
    flex-direction: column;
    width: 100%;
  }

  .btn {
    width: 100%;
    padding: 0.75rem;
    text-align: center;
  }

  .cookie-links {
    width: 100%;
    text-align: center;
    margin-top: 0.5rem;
  }
}
</style> 